import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLineChartUp05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11Zm-5.293-8.293a1 1 0 0 1-1.414-1.414l3.45-3.45c.085-.085.185-.186.281-.267.111-.094.28-.22.512-.295a1.5 1.5 0 0 1 .928 0c.232.075.4.2.512.295.096.081.196.182.28.266L14 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-3.45 3.45c-.085.085-.185.186-.281.267-.111.094-.28.22-.513.296a1.5 1.5 0 0 1-.926 0 1.508 1.508 0 0 1-.513-.296c-.096-.081-.196-.182-.28-.266L10 11.414l-3.293 3.293Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgLineChartUp05.displayName = 'LineChartUp05';
export default SvgLineChartUp05;
